import { AppointmentParticipantStatusEnum } from '../../enums';

export interface AppointmentParticipantInterface {
  id?: string;
  appointmentId?: string;
  userId?: string;
  metaData?: { [key: string]: any };
  status?: AppointmentParticipantStatusEnum;
}
